export default __webpack_public_path__ + "static/media/Fabrication.bea8bcdc.png";